export default "__VITE_ASSET__D2bUp4w$__"